const state = {}

const getters = {}

const mutations = {}

const actions = {}

export function prepareChetMetadata(context) {
  context.commit('setFeatures', { chet: { category: 'chet' } })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
